import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { summaryConstants, summaryModels } from '..';

export const useSummaryInsightDaily = ({ enabled }: { enabled?: boolean } = {}) =>
  useQuery<summaryModels.Insight>({
    queryKey: [summaryConstants.queryKeys.SUMMARY_INSIGHT_DAILY],
    queryFn: async () => {
      const res = await $api.get('/v1/summary-insight/daily');

      return res?.data?.data;
    },
    staleTime: Infinity,
    enabled
  });
